// extracted by mini-css-extract-plugin
export default {"bid-history-cta":"adc__bid-history-cta--TOiRG"};